import { render, staticRenderFns } from "./app.vue?vue&type=template&id=c22ef7d0&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&id=c22ef7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22ef7d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\1. 项目\\1. 工程\\4. 站点类\\科大基础热物理实验教学中心\\adth\\ly-vue-adiabaticThrottling\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c22ef7d0', component.options)
    } else {
      api.reload('c22ef7d0', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=c22ef7d0&scoped=true&", function () {
      api.rerender('c22ef7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\shell\\app.vue"
export default component.exports